import { Alert } from '@mui/material';

interface FormErrorMessageProps {
  message: string;
}

function FormErrorMessage(props: FormErrorMessageProps) {
  const { message } = props;

  return (
    <Alert
      severity="error"
      sx={{
        whiteSpace: 'pre',
        backgroundColor: 'error.main',
        color: 'text.primary',
      }}
      variant="filled"
    >
      {message}
    </Alert>
  );
}

export default FormErrorMessage;
